<template>
  <div class="home">
    <Carousel :list="config.banner.home"/>
    <Sections>
      <div class="container">
        <Title class="animation" anniset="animated fadeInDown" title="产品展示" description="规模大、实力强、品质保障、技术先进、储量丰富"></Title>
        <div class="row animation" anniset="animated fadeInUp">
            <div class="product-mobile col-lg-3 col-md-4"  v-for="(item,index) in config.product" :key="index" v-if="index < 5"  @click="goRouter(item.id)">
                <div class="items text-center sacleBig">
                    <div class="img">
                      <img class="img-responsive" :src="item.img" />
                    </div>
                    <h3>{{item.name}}</h3>
                    <!-- <p>by @mdo</p> -->
                    <p class="detail-p">{{item.description}}</p>
                </div>
            </div>         
        </div>
      </div>
    </Sections>
    <Sections>
        <div class="container about">
          <Title class="animation" anniset="animated fadeInDown"  title="公司简介" description="规模大、实力强、品质保障、技术先进、储量丰富"></Title>
          <div class="content animation" anniset="animated fadeInUp">
             <div class="img">
               <img :src="config.discriptiveImg" alt="">
             </div>
             <div class="info">
               <div v-html="config.introduce"></div>
               <div class="text-right"><button type="button btn-info" class="btn btn-primary" @click="goAbout">了解详情</button></div>
             </div>
          </div>
        </div>
    </Sections>
    <Sections bg="#292A2E">
      <div class="container partner" anniset="animated">
        <Title class="animation" anniset="animated fadeInDown" color="#ffffff !important" title="合作企业" description="规模大、实力强、品质保障、技术先进、储量丰富"></Title>
        <div class="row animation" anniset="animated fadeInUp">
            <div class="col-lg-3 col-md-4" v-for="(item,index) in config.partner" @click="open(item.url)" v-if="index < 5" :key="index">
                <div class="items text-center sacleBig">
                    <img class="img-responsive" :src="item.img" />
                    <h3 class="text-center">{{item.name}}</h3>
                    <!-- <p>by @mdo</p> -->
                    <p>{{item.description}}</p>
                </div>
            </div>         
        </div>
      </div>
    </Sections>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel'
import Title from '@/components/Title'
import Sections from '@/components/Sections'
export default {
  name: 'home',
  components: {
    Carousel,Title,Sections
  },
  data(){
    return{
      config
    }
  },
  mounted(){
    let documentClientHeight = document.documentElement.clientHeight || window.innerHeight;
    let containers = $('body').find('.animation');
    window.addEventListener("scroll",function(e){
      $.each(containers, function (index, item) {
          var top = item.getBoundingClientRect().top;
          if (documentClientHeight >= top) {
            $(item).addClass($(item).attr('anniset'));
          }
      });
    });
    $.each(containers, function (index, item) {
        let  top = item.getBoundingClientRect().top;
        if (documentClientHeight >= top) {
          $(item).addClass($(item).attr('anniset'));
        }
    });
  },
  methods:{
    goRouter(id){
      this.$router.push(`/detail/${id}`);
    },
    goAbout(){
      this.$router.push(`/about`);
    },
    open(url){
        window.open(url);
    }
  }
}
</script>
<style lang="less" scoped>
    .container .items{
      border: 1px solid #EEEEEE;
      padding: 10px;
      margin-bottom: 15px;
      .detail-p{
        text-overflow: ellipsis; /*超出部分裁剪，必须*/
        display: -webkit-box; /*必须*/
        -webkit-box-orient: vertical; /*属性规定框的子元素应该被水平或垂直排列。*/                    
        overflow: hidden; /*超出部分隐藏*/
        -webkit-line-clamp: 3; /*在第几行的时候超出部分隐藏*/
        height: 60px;
      }
      .img{
        width:100%;height:0;position: relative;padding-bottom: 100%;
        img{
          width:100%;height:100%;position: absolute;
        }
      }
    }
    .about{
      margin-bottom: 50px;
      .content{
        display: flex;
        flex-wrap: wrap;
        .img{
          // background-color: #0464AE;
          margin: 0 auto;
          height: 20vw;
          flex: 0 0 20vw;
          img{
            // width: 30vw;;
            height: 100%;
            // position: relative;
            // left: -20px;
            // top: 20px;
            background-color: #ffffff;
          }
        }
        .info{
          flex: 1;
          margin-left: 50px;
          text-indent: 32px;
          line-height: 30px;
          color: #1a1a1a;
          padding-top: 20px;
          letter-spacing: 1px;
          height: 20vw;
        }
      }
    }
    .partner{
      .items{
        position: relative;
        padding-top: 60px;
        margin: 80px 0;
        text-align: left;
        background-color: #ffffff;
        border-radius: 10px;
        min-height: 250px;
        p{
          height: 140px;
          overflow: hidden;
        }
        img{
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%,-50%);
          width: 120px;
          height: 120px;
          border: 10px solid #ffffff;
          border-radius: 50%;
        }
      }
    }
    @media only screen and (max-width: 1200px){
      .about{
        padding-bottom: 30px;
        .content{
          .info{
            padding: 0;
          }
        }
      }
    }

    @media only screen and (max-width: 1050px){
      .about{
        padding: 0;
        .content{
          display: block;
          .img{
            margin-bottom: 60px;
            width: 400px;
            height: 267px;
            img{
              width: 400px;
            }
          }
          .info{
            height: auto;
            margin: 0;
          }
        }
      }
    }

    @media only screen and (max-width: 500px){
      .about{
        .content{
          .img{
            width: calc(100vw - 100px);
            height: auto;
            img{
              width: calc(100vw - 100px);
            }
          }
        }
      }
      .product-mobile{
        padding: 0;
      }
    }
</style>
